import React from 'react';
import { Button, Dialog } from 'omni-common-ui';
import styles from './style.postcss';
import PropTypes from 'prop-types';

const InfoDialog = ({ children, isOpen, onOKClick }) =>
  <Dialog isOpen={isOpen}>
    <div className={styles.InfoDialog}>
      {children}
      <Button.Container align="center">
        <Button type={Button.Type.primary}
            onClick={() => onOKClick()}>
          OK
        </Button>
      </Button.Container>
    </div>
  </Dialog>;

InfoDialog.propTypes = {
  isOpen: PropTypes.bool,
  onOKClick: PropTypes.func,
  children: PropTypes.node,
};

export default InfoDialog;



// WEBPACK FOOTER //
// ./components/InfoDialog/index.jsx